import React from 'react'


const managerButtonSavePrev = (props) =>{
    
    const {type, value, valueTheme} = props;

    switch(type){
       
        case 'PREV-closed':
        // 美個區塊存檔下面多一顆預覽按鈕，先關閉 加上-closed
         return(value && 
            <div className="mangerweb-pb-1">
				<a href={`/managerweb/${value}/preview/${valueTheme}`} target='_blank' rel="noopener noreferrer"><span className='btn btn-primary'>預覽</span></a>
			</div>
        );
                
        default:
            return('');


    }
}

export default managerButtonSavePrev;